import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "text-subtle text-sm" }, "联系人", -1)

import { computed, ref } from 'vue'
import { debouncedWatch, useVModel } from '@vueuse/core'
import { useChatStore } from '@/store/user-chat'
import { useSearchStore } from '@/store/user-search'
import { truncate } from '@/utils/string-truncate'
import { useUserProfile } from '@/composables/user/useUserProfile'
import { useGroupProfile } from '@/composables/user/useGroupProfile'
import { tResultOfFriendSearch } from '@/types/user-search'
import FriendListAlphabetizedVue from '@/components/friend-list/FriendListAlphabetized.vue'
import MemberItemVue from './MemberItem.vue'


export default /*#__PURE__*/_defineComponent({
  props: {
    modelValue: null
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'update:modelValue', v: Set<string>): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    modelValue: Set<string>
}





const selected = useVModel(props, 'modelValue', emit)
const searchInputValue = ref('')

const chatStore = useChatStore()
/** 最近聊天列表 */
const chatList = computed(() => {
    return chatStore.chatList
        ?.filter((chat) => chat.type === 'single')
        .map((chat) => {
            const profile = chat.type === 'single' ? useUserProfile(chat.id) : useGroupProfile(chat.id)
            return {
                id: chat.id,
                type: chat.type,
                avatar:
                    profile.displayAvatar.value ||
                    (chat.type === 'single'
                        ? require('theme/icons/default-avatar.svg')
                        : require('theme/icons/default-avatar-group.svg')),
                label: profile.displayName.value,
            }
        })
})

const searchStore = useSearchStore()
const friendResult = ref<tResultOfFriendSearch[]>([])

debouncedWatch(
    searchInputValue,
    (value) => {
        if (!value.length) return

        friendResult.value = searchStore.getMatchedFriends(value)
    },
    { debounce: 400 }
)

return (_ctx: any,_cache: any) => {
  const _component_BaseSearchInput = _resolveComponent("BaseSearchInput")!
  const _component_base_expansion_item = _resolveComponent("base-expansion-item")!
  const _component_base_checkbox = _resolveComponent("base-checkbox")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_BaseSearchInput, {
      modelValue: searchInputValue.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchInputValue).value = $event)),
      class: "mt-3 mb-2 mr-4"
    }, null, 8, ["modelValue"]),
    (!searchInputValue.value.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_base_expansion_item, {
            class: "mr-4",
            label: "最近聊天",
            "default-opened": ""
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(chatList), (chat, index) => {
                return (_openBlock(), _createBlock(MemberItemVue, {
                  key: index,
                  label: chat.label,
                  avatar: chat.avatar,
                  "model-value": _unref(selected).has(chat.id as string),
                  "onUpdate:modelValue": ($event: any) => (_unref(selected).has(chat.id as string)
                        ? _unref(selected).delete(chat.id as string)
                        : _unref(selected).add(chat.id as string)
                    )
                }, null, 8, ["label", "avatar", "model-value", "onUpdate:modelValue"]))
              }), 128))
            ]),
            _: 1
          }),
          _createVNode(_component_base_expansion_item, {
            class: "mr-2",
            label: "好友"
          }, {
            default: _withCtx(() => [
              _createVNode(FriendListAlphabetizedVue, {
                onSelectFriend: _cache[1] || (_cache[1] = ($event: any) => (_unref(selected).add($event))),
                "same-background-color": "",
                "item-class": 'cursor-pointer'
              }, {
                default: _withCtx(({ address }) => [
                  _createVNode(_component_base_checkbox, {
                    "model-value": _unref(selected).has(address),
                    "onUpdate:modelValue": ($event: any) => (_unref(selected).add(address))
                  }, null, 8, ["model-value", "onUpdate:modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (friendResult.value.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _hoisted_4,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(friendResult.value, (item) => {
                  return (_openBlock(), _createBlock(MemberItemVue, {
                    key: item.address,
                    label: item.remark || _unref(truncate)(item.nickname) || _unref(truncate)(item.address),
                    avatar: item.avatar,
                    "model-value": _unref(selected).has(item.address),
                    "onUpdate:modelValue": ($event: any) => (_unref(selected).add(item.address))
                  }, null, 8, ["label", "avatar", "model-value", "onUpdate:modelValue"]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]))
  ]))
}
}

})